module.exports = __webpack_public_path__ + "img/w45b.7e5a8a78.jpg";